import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { IPreparaciones } from 'src/app/interfaces/preparaciones';
import FuncLib from 'src/app/providers/funcionesLib';
import { UsuarioService } from 'src/app/services/datos/usuario.service';
import { ModalRecogidaService } from 'src/app/services/modal-recogida.service';
import { NotificacionesService } from 'src/app/services/notificaciones.service';

@Component({
  selector: 'app-modal-recogida-modif',
  templateUrl: './modal-recogida-modif.component.html',
  styleUrls: ['./modal-recogida-modif.component.scss'],
})
export class ModalRecogidaModifComponent implements OnInit, OnDestroy {
  @Input() preparacion?: IPreparaciones;
  public funcLib: FuncLib = new FuncLib();

  enviado: boolean = false;
  loading: boolean = false;

  public recogidaForm: FormGroup = new FormGroup({});
  preparacionSubscription: Subscription | undefined;

  constructor(
    public modalrecogidaSrv: ModalRecogidaService,
    private notificacionesSrv: NotificacionesService,
    private usuarioSrv: UsuarioService,
    private fb: FormBuilder
  ) { }

  ngOnDestroy(): void {
    this.preparacionSubscription?.unsubscribe();
  }

  ngOnInit(): void {

    this.recogidaForm = this.fb.group({
      cantidad: [Number(this.modalrecogidaSrv.preparacion?.cant_recogida), [Validators.required, Validators.min(0)]],
      descripcion: ['', [Validators.required, Validators.minLength(4), Validators.maxLength(150)]],
      username: [this.usuarioSrv.userdata.username],
    });

    // Suscribirse al objeto stock y actualizar el formulario cuando cambie, así ligamos la regularización a un rec de Stock
    this.preparacionSubscription = this.modalrecogidaSrv.preparacionSubject.subscribe(
      (preparacion: IPreparaciones) => {
        this.recogidaForm.patchValue({
          cantidad: Number(preparacion?.cant_recogida),
          descripcion: 'Se modifica la cantidad recogida',
        });
        this.enviado = false;
      }
    );
  }

  cerrarModal() {
    this.modalrecogidaSrv.preparacion = undefined;
    this.modalrecogidaSrv.cerrarModal();
  }

  cerrarModalClickOutside(event: MouseEvent) {
    // Cerrar modal al hacer click fuera del modal
    if ((event.target as HTMLElement).classList.contains('modal')) {
      // this.cerrarModal();
    }
  }

  get f() {
    return this.recogidaForm.controls;
  }

  enviar() {
    if (!this.modalrecogidaSrv.preparacion) return;

    this.enviado = true;

    console.log('__enviar() this.modalrecogidaSrv.preparacion ', this.modalrecogidaSrv.preparacion);

    if (this.recogidaForm.invalid) {
      console.log('ERRORES:', this.recogidaForm);
      return;
    }

    const cantOrigen = Number(this.modalrecogidaSrv.preparacion?.cant_recogida);
    const cantNueva = Number(this.recogidaForm.value.cantidad);

    // Validar que la cantidad no sea mayor que la cantidad de recogida 
    if (cantNueva > cantOrigen) {
      this.recogidaForm.get('cantidad')!.setErrors({ apiError: 'La cantidad no puede ser mayor que la cantidad recogida' });
      return;
    }
    // Validar que haya algún cambio en la cantidad
    if (cantNueva === cantOrigen) {
      this.recogidaForm.get('cantidad')!.setErrors({ apiError: 'No se ha modificado la cantidad recogida' });
      return;
    }

    // Todo ok, enviar al BackEnd
    this.loading = true;
    this.modalrecogidaSrv.regularizaPrep(this.modalrecogidaSrv.preparacion.id, this.recogidaForm.value)
      .subscribe((resp) => {
        this.loading = false;

        console.log('__enviar() resp', resp);

        if (resp.error) {
          this.notificacionesSrv.aviso('error', resp.mensaje);
          for (let controlName in resp.mensaje) {
            this.recogidaForm
              .get(controlName)!
              .setErrors({ apiError: resp.mensaje[controlName] });
          }
          return;
        }

        this.notificacionesSrv.aviso('success', resp.mensaje);
        // Actualizar preparación
        this.modalrecogidaSrv.preparacion = resp.data;
        this.cerrarModal();
        return;
      });
  }

  ///   AUX   ///
}
